import { render, staticRenderFns } from "./ledger_list_m.vue?vue&type=template&id=0462f698&scoped=true&"
import script from "./ledger_list_m.vue?vue&type=script&lang=js&"
export * from "./ledger_list_m.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0462f698",
  null
  
)

export default component.exports